import { useSelector } from 'react-redux'

import { selectUsers } from '@/features/domain/user'

import { useTexts } from './useTexts'

import { useController } from '../../../../../../hooks/useController'
import { form } from '../../../../../formState'

export function Password() {
  const texts = useTexts()

  // the password belongs to the user being edited, not to the logged in admin
  const {
    data: { userId },
  } = useController()
  const users = useSelector(selectUsers)
  const username = users[userId]?.username

  const validationSummaryItems = form.useStandardPasswordValidations('new-password', { username })

  return (
    <form.Fieldset>
      <form.Password
        name="new-password"
        testId="new-password"
        label={texts.newPassword}
        validateOn="blur change"
        errorVisibility="accent-only"
        textfieldProps={{
          autoComplete: 'new-password',
        }}
      />

      <form.ValidationSummary items={validationSummaryItems} mode="show-errors" />
    </form.Fieldset>
  )
}
